import React, { useState } from "react";
import theme from "../../../styles/theme";
import TabsNavVertical from "../../reusable/Tab/TabsNavVertical";

/**
 * Sidebar
 * Composant pour afficher une barre latérale verticale avec :
 *  - un header / toggle pour réduire ou développer la sidebar
 *  - une liste verticale de tabs (via TabsNavVertical)
 * 
 * Props :
 *  - items : Array d'objets { label, icon } représentant les onglets de la sidebar
 *  - initialActive : index de l'onglet actif par défaut
 *  - style : styles supplémentaires à appliquer au conteneur
 */
const Sidebar = ({ items = [], initialActive = 0, style = {}, onItemClick  }) => {
  const [expanded, setExpanded] = useState(true);        // État sidebar étendue ou réduite
  const [activeIndex, setActiveIndex] = useState(initialActive); // Onglet actif

  // Prépare les tabs pour TabsNavVertical : masque le label si sidebar réduite
  const tabs = items.map((item) => ({
  ...item,
  label: expanded ? item.label : item.label ? "" : item.label,
}));

 

  return (
    <div
      style={{
        width: expanded ? 180 : 50,                // largeur dynamique
        display: "flex",
        flexDirection: "column",
        backgroundColor: theme.colors.background.sidebar,                   // couleur de fond
        borderRight: `2px solid rgba(0,0,0,0.08)`,
        backdropFilter: "blur(2px)",
        //borderRight: `2px solid ${theme.colors.borders.sidebar}`,
        transition: "width 0.3s",
        boxSizing: "border-box",
        backdropBlur:theme.effects.backdropBlur,
       
        ...style,
      }}
    >
      {/* Header / Toggle */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 12px",
          height: 40,
          borderBottom: `1px solid ${theme.colors.borders.default}`,
          backgroundColor: theme.colors.background.surface,
        }}
      >
        {/* Label du header */}
        <span
          style={{
            fontWeight: 600,
            fontSize: "1rem",
            color: theme.colors.text.primary,
            display: expanded ? "inline" : "none",
          }}
        >
          {/* Modules ->> Ici c'est le label à placer en entête du panneau */}
        </span>
        {/* Bouton pour réduire / étendre la sidebar */}
        <button
          onClick={() => setExpanded(!expanded)}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: theme.spacing.sm,
          }}
        >
          <img
            src={
              expanded
                ? "/assets/icones/chevrons-left.svg"
                : "/assets/icones/chevrons-right.svg"
            }
            alt="Toggle"
            style={{ width: 20, height: 20 }}
          />
        </button>
      </div>

      {/* TabsNavVertical pour les items */}
      <div
        style={{
          flex: 1,                         // prend tout l'espace vertical restant
          display: "flex",
          flexDirection: "column",
          boxSizing: "border-box",
          paddingLeft: "0px",              // ajustement de distance à gauche
          marginLeft: "-10px",
          backgroundColor: theme.colors.background.surface,
        }}
      >
        <TabsNavVertical
          labels={tabs}
          activeIndex={activeIndex}
          onChange={(index) => {
            setActiveIndex(index);
            if (onItemClick) onItemClick(items[index].component);
          }}
          orientation="vertical"
        />

        {/* <TabsNavVertical
          labels={tabs}
          activeIndex={activeIndex}
          onChange={setActiveIndex}
          orientation="vertical"           // orientation verticale
        /> */}
      </div>
    </div>
  );
};

export default Sidebar;
